export class Candidate {
    id: any = null;
    name: any;
    firstName: any;
    lastName: any;
    workphone: any;
    mobilephone: any;
    email: any;
    im: any;
}
